@if(salesUnit(); as unit) {
    <div class="flex flex-row justify-between items-center flex-wrap">
      <div class="flex flex-col">
        <div class="flex flex-row items-center">
          <span class="text-lg font-bold mr-2">
            {{unit.unit.key}}
          </span>
          <span class="">
            ({{unit.unit.name}})
          </span>
        </div>
        <div class="flex flex-row">
          <span class="font-semibold text-sm mr-2">Faktor:</span>
          <span>{{unit.factor  | number:'1.2-5'}}</span>
        </div>
      </div>
      <div class="flex flex-wrap gap-2 items-center">
        @if (unit.ean?.trim()) {
          <soft-barcode [data]="unit.ean" [labelType]="unit.ean.length <= 8 ? 'ean8' : 'ean13'" size="sm" />
        }
        @for (ean of unit.additionalEanList; track ean) {
          @if (ean?.trim()) {
            <soft-barcode [data]="ean" [labelType]="ean.length <= 8 ? 'ean8' : 'ean13'" size="sm" />
          }
        }
      </div>
    </div>
}
